
export const baseConfig = (config) => {
    config.mobile_cart = false;
    config.customer = 'consumer';
    config.root_font_size = '16px';
    config.cart_toolbar_bg_color = 'white';
    config.cart_toolbar_top = '2.85rem';
    config.cart_panel_header_margin = '0.1rem 0 0.5rem !important';
    config.kiosk_bg_color = "#e6e6e6";
    config.kiosk_primary_button_background = 'linear-gradient(#4ea4c3, #007aa1)';
    config.kiosk_form_button_bg_color = '#EBA900';
    config.kiosk_form_button_font_color = '#101820';
    config.kiosk_form_button_border_color = '#EBA900';
    config.kiosk_form_button_border = '2px solid #EBA900';
    config.kiosk_login_bg = 'white';
    config.kiosk_form_bg_color = 'white';
    config.kiosk_form_border_color = '#EBA900';
    config.kiosk_form_header_font_color = '#101820';
    config.kiosk_form_message_font_color = '#101820';
    config.kiosk_form_label_font_color = '#101820';
    config.kiosk_form_label_font_weight = 'bold';
    config.kiosk_form_access_code_input_bg_color = 'white';
    config.kiosk_form_access_code_input_border_color = '#101820';
    config.kiosk_form_access_code_input_border = '2px solid #101820';
    config.kiosk_form_access_code_input_font_color = '#101820';
    config.kiosk_topbar_logo = '/img/brand-black-on-white.svg'
    config.kiosk_topbar_logo_german = '/img/brand-black-on-white.svg'
    config.kiosk_topbar_logo_french = '/img/brand-black-on-white.svg'
    config.kiosk_topbar_logo_height = '3rem';
    config.pwa_home_bg = 'white';
    config.pwa_checkmark_color = '#06befa';
    config.pwa_login_forgot_btn_bg_color = '#e2e7ff';
    config.pwa_login_forgot_btn_font_color = '#394AA7';
    config.pwa_login_logo = '/img/brand.svg';
    config.pwa_login_logo_height = 'auto';
    config.pwa_login_mini_logo = '/img/logo-yellow.svg';
    config.pwa_login_sideheader_bg_color = '#394AA7';
    config.pwa_pswipe_footer_logo = '';
    config.pwa_pswipe_footer_logo_german = '';
    config.pwa_pswipe_footer_logo_french = '';
    config.pwa_navbar_desktop_brand_logo = '/img/brand-black-on-white.svg';
    config.pwa_navbar_desktop_brand_logo_german = '/img/brand-black-on-white.svg';
    config.pwa_navbar_desktop_brand_logo_french = '/img/brand-black-on-white.svg';
    config.pwa_pswipe_store_link = 'https://shop.harrypotterexhibition.com/';
    config.pwa_home_bg_color = 'white';
    config.pwa_card_label_border_color = 'white';
    config.pwa_selection_main_bg_color = 'black';
    config.pwa_selection_main_font_color = 'white';
    config.pwa_selection_second_bg_color = 'white';
    config.pwa_selection_second_font_color = 'black';
    config.pwa_selection_font_color = 'black';
    config.pwa_selection_bg_color = 'white';
    config.pwa_card_label_bg_color = 'white';
    config.pwa_galleryimage_bg = 'white';
    config.pwa_stories_bg = 'white';
    config.pwa_story_title_bg_color = 'white';
    config.pwa_story_title_font_color = 'black';
    config.pwa_story_bg = 'white';
    config.pwa_galleryimage_font_color = 'black';
    config.pwa_navbar_item_bg_color = 'white';
    config.pwa_navbar_font_color = 'black';
    config.pwa_navbar_bg_color = 'white';
    config.pwa_navbar_hover_bg_color = 'white';
    config.pwa_navbar_hover_font_color = 'blue';
    config.pwa_default_font_color = 'black';
    config.pwa_default_bg_color = 'white';
    config.pwa_default_button_bg_color = '#F0948F';
    config.pwa_default_button_font_color = 'white';
    config.legal_notes = 'WIZARDING WORLD and all related trademarks, characters, names, and indicia are © & ™ Warner Bros. Entertainment Inc. Publishing Rights © JKR. (s22)';
    config.kiosk_logout_btn_bg = '#EBA900';
    config.kiosk_logout_btn_border = '1px solid #dcdcdc';
    config.kiosk_logout_btn_box_shadow = '0 0 2px #101820';
    config.kiosk_logout_btn_font_color = '#101820';
    config.kiosk_logout_btn_padding = '0rem 1rem';
    config.kiosk_toolbar_bg = '#101820';
    config.kiosk_toolbar_header_font_color = '#EBA900';
    config.kiosk_toolbar_header_padding = '0';
    config.kiosk_toolbar_header_margin = '0rem 1.5rem 0.5rem 1rem !important';
    config.kiosk_cart_count_font_color = '#2b8eb0';
    config.kiosk_cart_icon_margin_right = '0.5rem';
    config.kiosk_select_all_font_color = '#343434';
    config.kiosk_modal_header_font_color = '#EBA900';
    config.kiosk_modal_content_font_color = '#EBA900';
    config.kiosk_modal_border_color = '#EBA900';
    config.kiosk_modal_button_action_bg_color = '#EBA900';
    config.kiosk_modal_button_action_font_color = '#101820';
    config.kiosk_modal_button_action_border = '1px solid #EBA900';
    config.kiosk_modal_bg_color = 'white';
    config.sub_font = '"Source Sans Pro", sans-serif';
    config.main_font = '"Source Sans Pro", sans-serif';
    config.kiosk_inactivity_timeout = 20;
    config.kiosk_auto_logout_countdown = 20;
    config.login_error = "No photos for this account.  Please scan a band that was used at the photo station"
    config.select_all_enabled = '#EBA900';
    config.select_all_disabled = 'rgb(148 148 148)';
}
